// extracted by mini-css-extract-plugin
module.exports = {"navbarHt":"55px","sidebarWd":"300px","maxWd":"1660px","maxHt":"2000px"};